import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    height: 100vh;
`;

export const ContainerRight = styled.div`
    width: 100%;
    background-image: url("../assets/login/loginbanner.svg");
    background-size: cover;
    height: 100vh;

    @media (max-width: 768px){
        display: none;
    }

`;

export const ContainerLeft = styled.div`
    width: 100%;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px){
        background-image: url("../assets/login/loginbanner.svg");
        background-size: cover;
        height: 100vh;
    }

`;

export const Form = styled.form`


    @media (max-width: 768px){
        width: 100%;
        max-width: 328px;
        background-color: #FFFFFF;
        padding: 15px;
        margin: 15px;
        border-radius: 10px;
    }

`;

export const Logo = styled.img`
    width: 96px;
    height: 96px;
    margin-bottom: 26px;
`;

export const WelcomeText = styled.p`
    margin-bottom: 12px;
`;

export const SmallText = styled.p`
    margin-bottom: 36px;
`;

export const InputIconContainer = styled.div`
    display: flex;
    align-items:center;
    border-radius: 4px;
    border: 1px solid #CCC;
    background: #FFF;    
    max-height: 48px;
    padding: 12px;
    margin-bottom: 39px;
`;

export const Input = styled.input`
    border: none;
    width: 100%;
    padding: 12px;

    transition: border-color 0.3s;

    &:focus{
      border-color: transparent;
    }
`;

export const OTPContainer = styled.div`

    .containerStyle{
        gap: 22px;     
    }
    margin: 10px 0px 54px 0px;   

`;

export const Button = styled.button`
    width: 100%;
    height: 48px;
    border-radius: 4px;
    background: linear-gradient(180deg, #FF9250 0%, #F37021 100%);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    color: #FFFFFF;
`;

export const Label = styled.label`
`;